module.exports = __webpack_public_path__ + "static/media/fptp_ballot_1.724b1247.png";